import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=7bd9f47b&scoped=true"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=7bd9f47b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd9f47b",
  null
  
)

export default component.exports